import { useEffect, useState } from "react";
import { useFetchTrackingEvents } from "../hooks/use-queries";
import { orderBy } from "lodash";
import env from "../config/env";

export default function DownloadLaporan(props) {
  const { data: eventData } = useFetchTrackingEvents(props.id);

  const [name, setName] = useState("");
  const [meta, setMeta] = useState([]);

  useEffect(() => {
    const finishEvents = orderBy(eventData.filter((x) => x.type === "FINISHED"), ["created_at"], ["desc"]);

    if (finishEvents.length) {
      const lastEvent = finishEvents[0];
      setName(lastEvent.meta);
      setMeta(lastEvent.meta);
    }
  }, [eventData]);

  if (!meta.length) {
    return <></>;
  }

  return (
    <>
      <div className="mt-4">
        <h1 className="font-Rubik font-medium text-[#787878] text-[16px] ">Laporan Qurban </h1>
        <div className="bg-[#82BE41] h-[3px] w-[80px] rounded-[5px] mt-2"></div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 mt-8 font-Rubik text-base sm:text-[15px] font-semibold text-[#787878]">
        <div className="text-center">
          <div className="bg-[#F5F5F5] py-1 font-light">
            <h3>File Laporan</h3>
          </div>
          {name.map((nama) => (
            <h3 key={nama.id} className="my-8 px-8 max-w mx-auto">
              Laporan Penyaluran a.n {nama.name.replace(".pdf", "")}
            </h3>
          ))}
        </div>
        <div className="text-center">
          <div className="bg-[#F5F5F5] py-1 font-light">
            <h3>Aksi</h3>
          </div>
          <div className="text-center mt-6">
            {meta.map((media) => (
              <div key={media.id}>
                <a href={`${env.apiUrlNext}/media/${media.id}/download`} rel="noopener noreferrer">
                  <button className="py-3 mb-2 px-16 bg-[#84db00] hover:bg-[#6EB700] transition duration-300 text-white font-Rubik rounded-[15px]">Download</button>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
